import React from 'react';
import Navbar from './Component/Navbar/Navbar';
// import Navbar from './Component/Navbar/Navbar';
import Footer from './Component/Footer/Footer';
// ?ooter from './Footer';

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
